import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { INFO_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const InfoMasterApi = createApi({
  reducerPath: "infotermMaster",
  baseQuery,
  tagTypes: ["Info"],
  endpoints: (builder) => ({
    getInfoterm: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: INFO_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: INFO_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["Info"],
    }),
    getInfotermById: builder.query({
      query: (id) => {
        return {
          url: `${INFO_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["Info"],
    }),
    addInfoterm: builder.mutation({
      query: (payload) => ({
        url: INFO_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["Info"],
    }),
    updateInfoterm: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${INFO_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Info"],
    }),
    deleteInfoterm: builder.mutation({
      query: (id) => ({
        url: `${INFO_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Info"],
    }),
  }),
});

export const {
  useGetInfotermQuery, useGetInfotermByIdQuery, useAddInfotermMutation, useUpdateInfotermMutation, useDeleteInfotermMutation
} = InfoMasterApi;

export default InfoMasterApi;
